import { defineStore } from "pinia";

import { getUserSettingsDefault } from "~/common/defaults/user-settings.default";
import type { UpdateUserSettingsDto } from "~/common/interfaces/dto/user-settings/update-user-settings.dto";
import type { UserSettings } from "~/common/interfaces/entities/user-settings.interface";

export const useUserSettingsStore = defineStore(
	"userSettings",
	() => {
		const userSettings = ref<UserSettings>(getUserSettingsDefault());

		const getMe = async (): Promise<UserSettings> => {
			userSettings.value = await useNuxtApp().$apiFetch<UserSettings>("/user-settings");

			return userSettings.value;
		};
		const patchMe = (dto: UpdateUserSettingsDto): Promise<UserSettings> => {
			return useNuxtApp().$apiFetch<UserSettings>("/user-settings", {
				method: "PATCH",
				body: dto
			});
		};

		return {
			userSettings,

			getMe,
			patchMe
		};
	}
);
